import React, {ChangeEvent, FunctionComponent} from "react";
import {Theme, withTheme} from "@material-ui/core";
import {TextValidator, ValidatorComponentProps} from "react-material-ui-form-validator";
import {TextFieldProps} from "material-ui";

type CommonTextFieldProps = {
    onChangeText: (text: string | number) => void;
    theme: Theme;
} & ValidatorComponentProps & TextFieldProps;

const ValidateTextInput: FunctionComponent<CommonTextFieldProps> = (props) => {

    const handleChange = (e: ChangeEvent<HTMLInputElement>): void => props.onChangeText(e.target.value);

    return (
        <TextValidator
            name={props.name}
            label={props.label}
            validators={props.validators}
            errorMessages={props.errorMessages}
            value={props.value}
            onChange={handleChange}
            disabled={props.disabled}
            className={props.className}
            style={props.style}
            InputLabelProps={{style: {color: props.disabled ? "#eee" : "#999"}}}
            InputProps={{style: {color: props.disabled ? props.theme.palette.secondary.light : "#000"}}}
            validatorListener={props.validatorListener}
        />
    );
};

export default withTheme(ValidateTextInput);
